<template>
  <div class="enterprise-box">
    <div class="title">完善企业信息</div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="140px"
      class="ruleForm"
    >
      <el-form-item label="公司全称" prop="name">
        <el-input
          placeholder="请输入公司全称"
          maxlength="24"
          v-model="ruleForm.name"
        ></el-input>
      </el-form-item>
      <el-form-item label="公司简称" prop="shortName">
        <el-input
          placeholder="请输入公司简称"
          maxlength="10"
          v-model="ruleForm.shortName"
        ></el-input>
      </el-form-item>
      <el-form-item label="姓名" prop="contactName">
        <el-input
          placeholder="请输入您的姓名"
          maxlength="4"
          v-model="ruleForm.contactName"
        ></el-input>
      </el-form-item>
      <el-form-item label="联系人手机号" prop="contactPhone">
        <el-input
          placeholder="请输入您的手机号"
          maxlength="11"
          v-model="ruleForm.contactPhone"
        ></el-input>
      </el-form-item>
      <el-form-item label="联系人E-mail" prop="contactEmail">
        <el-input
          placeholder="请输入E-mail"
          maxlength="50"
          v-model="ruleForm.contactEmail"
          @keyup.enter.native="saveHandler('ruleForm')"
        ></el-input>
      </el-form-item>
      <el-form-item label="任职职位" prop="contactPosition">
        <el-input
          placeholder="请输入任职职位"
          maxlength="30"
          v-model="ruleForm.contactPosition"
          @keyup.enter.native="saveHandler('ruleForm')"
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="btns">
      <el-button type="primary" @click="saveHandler('ruleForm')"
        >完成注册，下一步</el-button
      >
    </div>

    <div class="viewer" v-if="dialogVisible">
      <div class="img-box" @click="goBackStage">
        <div class="close"><i class="el-icon-close"></i></div>
        <img src="@/static/images/gift.png" />
      </div>
    </div>
  </div>
</template>

<script>
import { isEmail, isMobile } from '@/untils/validate'
import { REPORT_API } from "@/api.js";
export default {
  props: ['role'],
  data() {
    return {
      dialogVisible: false,
      ruleForm: {
        name: '',
        shortName: '',
        contactName: '',
        contactPhone: '',
        contactEmail: '',
        contactPosition: '',
      },
      info: {},
      rules: {
        name: [{ required: true, message: '请输入公司全称', trigger: 'blur' }],
        shortName: [
          { required: true, message: '请输入公司全称', trigger: 'blur' },
        ],
        contactName: [
          { required: true, message: '请输入您的姓名', trigger: 'blur' },
        ],
        contactPhone: [
          { required: true, message: '请输入您的手机号', trigger: 'blur' },
        ],
        contactEmail: [
          { required: true, message: '请输入E-mail', trigger: 'blur' },
        ],
      },
      backURL: '',
    }
  },
  mounted() {
    this.info = this.$cookies.get('hr_token')
    if (this.info) {
      this.$axios.defaults.headers.common['authorization'] = this.info.token
    } else {
      //没有登录
      this.$message.error('您的登录状态失效，请重新登录！')
      this.$router.push('/login')
    }
    this.backURL = this.$route.query.backURL
  },
  methods: {
    goBackStage() {
      if (this.backURL) {
        this.$router.push(this.backURL)
      } else {
        location.href = 'https://kao.acmcoder.com/b/'
      }
    },
    saveHandler(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!isMobile(this.ruleForm.contactPhone)) {
            this.$message.error('亲，手机号格式不正确，请重试！')
            return
          }
          if (!isEmail(this.ruleForm.contactEmail)) {
            this.$message.error('亲，E-mail格式不正确，请重试！')
            return
          }

          let post = {
            name: this.ruleForm.name.trim(),
            shortName: this.ruleForm.name.trim(),
            contactName: this.ruleForm.contactName.trim(),
            contactPhone: this.ruleForm.contactPhone.trim(),
            contactPhoto: '',
            contactEmail: this.ruleForm.contactEmail.trim(),
            contactPosition: this.ruleForm.contactPosition.trim(),
          }
          this.$axios
            .post(
              `${REPORT_API}/api/enterprise/addEntInfo`,
              post
            )
            .then((res) => {
              if (res.data.code == 0) {
                this.$message.success('信息保存成功！')
                const hr_token = JSON.stringify({
                  token: res.data.data.kao_token,
                  finish: 1,
                  mobile: this.ruleForm.contactPhone.trim(),
                })
                document.cookie =
                  'hr_token=' +
                  hr_token +
                  '; max-age=' +
                  60 * 60 * 12 +
                  '; path=/;'
                document.cookie =
                  'kao_token="' +
                  res.data.data.kao_token +
                  '"; max-age=' +
                  60 * 60 * 12 +
                  '; path=/; domain=.acmcoder.com;'

                // this.dialogVisible = true
                setTimeout(()=>{
                  this.goBackStage()
                },200)
              } else {
                this.$message.error(res.data.message)
              }
            })
        } else {
          return false
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.enterprise-box {
  margin: 0px auto 0px;
  .title {
    font-size: 20px;
    padding: 0px 0px 20px;
    text-align: center;
    border-bottom: 1px solid #ccc;
    margin-bottom: 20px;
    color: #999;
  }
  .ruleForm {
    width: 300px;
    margin: 20px 20px 0px 40px;
  }
  .input {
    padding: 10px 0px;
  }
  .btns {
    width: 280px;
    margin: 0px auto;
  }
}
.viewer {
  position: fixed;
  background: rgba(0, 0, 0, 0.6);
  display: grid;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  .img-box {
    margin: auto;
    position: relative;

    .close {
      position: absolute;
      right: -20px;
      font-size: 30px;
      color: #fff;
      font-weight: bold;
      cursor: pointer;
    }
    img {
      width: 600px;
      cursor: pointer;
    }
  }
}

@media screen and (max-width: 600px) {
  .enterprise-box {
    .ruleForm {
      width: initial;
      margin: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/account/model/comp-info.vue